import React from 'react';
import L from 'leaflet';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { Marker } from 'react-leaflet';
import stop from '../../assets/images/map_dot_layer.svg';
import highlightedStop from '../../assets/images/map_dot_highlight_layer.svg';
import {
  toggleHighlight,
  toggleDisplays
} from '../../state/uiControl/uiControl.actions';
import { isMobile } from '../../util';
import { longitudeOffsets } from '../LeafletMap';
import { Entry } from '../../services/types';


const stopsIcon = new L.Icon({
  iconUrl: stop,
  iconSize: [25, 25]
});

const stopsHighlight = new L.Icon({
  iconUrl: highlightedStop,
  iconSize: [50, 50]
});

type EntryMarkerProps = {
  entry: Entry;
  locationID: number;
}

export const EntryMarker: React.FC<Props> = (
  {
    entry,
    locationID,
    highlightedEntries,
    toggleHighlight,
    toggleDisplays
  }
) => {

  if (entry.lat === undefined || entry.long === undefined) {
    return null;
  }

  return <div
    key={"entry" + entry.id + 0}
  >
    {longitudeOffsets.map((longOffset, index) => (
      <Marker
        key={"entry" + entry.id + index}
        entry={entry}
        locationID={locationID}
        position={[
          entry.lat!,
          entry.long! + longOffset
        ]}
        zIndexOffset={230}
        icon={highlightedEntries[locationID] && !isMobile() ? stopsHighlight : stopsIcon}
        riseOnHover={true}
        onmouseover={(event: L.LeafletMouseEvent) => toggleHighlight(event.target.options.locationID)}
        onmouseout={(event: L.LeafletMouseEvent) => toggleHighlight(event.target.options.locationID)}
        onClick={(event: L.LeafletMouseEvent) => toggleDisplays(event.target.options.entry)}
      />
    ))}
  </div>;
};

const mapStateToProps = (state: RootState, ownProps: EntryMarkerProps) => ({
  entry: ownProps.entry,
  locationID: ownProps.locationID,
  highlightedEntries: state.voyagesData.highlightedEntries
});

const dispatchProps = {
  toggleHighlight,
  toggleDisplays
};

type Props = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(EntryMarker);